"use strict";

var ISurveyComponent;
(function (ISurveyComponent) {
  ISurveyComponent.DOM_PROMPT_TAGNAME = "Prompt";
  ISurveyComponent.DOM_COMMENT_TAGNAME = "Comment";
  ISurveyComponent.DOM_RATING_TAGNAME = "Rating";
  ISurveyComponent.DOM_MULTIPLECHOICE_TAGNAME = "MultipleChoice";
  ISurveyComponent.DOM_INTERCEPT_TAGNAME = "Intercept";
  ISurveyComponent.JSON_INTERCEPT_KEYNAME = "intercept";
  ISurveyComponent.JSON_INTERCEPTURL_KEYNAME = "url";
  ISurveyComponent.JSON_PROMPT_KEYNAME = "prompt";
  ISurveyComponent.JSON_PROMPTYESTEXT_KEYNAME = "yesButtonText";
  ISurveyComponent.JSON_PROMPTNOTEXT_KEYNAME = "noButtonText";
  ISurveyComponent.JSON_COMMENT_KEYNAME = "comment";
  ISurveyComponent.JSON_RATING_KEYNAME = "rating";
  ISurveyComponent.JSON_RATINGOPTIONS_KEYNAME = "options";
  ISurveyComponent.JSON_TITLE_KEYNAME = "title";
  ISurveyComponent.JSON_QUESTION_KEYNAME = "question";
  ISurveyComponent.JSON_MULTIPLECHOICE_KEYNAME = "multipleChoice";
  ISurveyComponent.JSON_APPLICATION_KEYNAME = "application";
  ISurveyComponent.JSON_EXTENDEDMANIFESTDATA_KEYNAME = "extendedManifestData";
  ISurveyComponent.JSON_SURVEYSTRINGS_KEYNAME = "surveyStrings";
  ISurveyComponent.JSON_SURVEYSPECIFICDATA_KEYNAME = "surveySpecificData";
})(ISurveyComponent || (ISurveyComponent = {}));
module.exports = ISurveyComponent;